module.exports = AppCore.default.React;